import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../_services/_nav.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Table } from 'primeng/table';
import { TipoRespaldoService } from '../../_services/tipo-respaldo.service';
import { TipoRespaldoCategoriaService } from '../../_services/tipo-respaldo-categoria.service';
import { TipoRespaldo } from '../../_models/tipo-respaldo';
import { TipoRespaldoCategoria } from '../../_models/tipo-respaldo-categoria';

@Component( {
  selector: 'app-tipo-respaldo-detalle',
  templateUrl: 'tipo-respaldo-detalle.component.html'
} )

export class TipoRespaldoDetalleComponent implements OnInit {

  carInformacionInicial = true;
  tipoRespaldo: TipoRespaldo;
  lisTipoRespaldoCategoria: TipoRespaldoCategoria[] = [];
  carTabla = true;
  columnas: any[];
  @ViewChild('dt') tabla: Table;

  constructor( private serTipoRespaldo: TipoRespaldoService,
               private serTipoRespaldoCategoria: TipoRespaldoCategoriaService,
               private navServicio: NavService,
               private route: ActivatedRoute,
               private location: Location,
               private fb: FormBuilder,
               private router: Router,
               private autServicio: AutenticacionService,
               private conServicio: ConfirmationService ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.serTipoRespaldo.obtenerPorId( params[ 'id' ] ).subscribe( tipoRespaldo => {
          this.tipoRespaldo = tipoRespaldo;
          this.serTipoRespaldoCategoria.listadoPorIdRespaldo( this.tipoRespaldo.idTipoRespaldo ).subscribe( tipoRespaldoCategoria => {
            this.lisTipoRespaldoCategoria = tipoRespaldoCategoria;
            this.carServiciosIniciales();
          } );
        } );
      }
    } );

  }

  carServiciosIniciales() {

    this.columnas = [
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'TIPORESPALDO.LBL_NOMCAT' ), sort: true },
      { field: 'habilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true }
    ];

    this.carTabla = false;
    this.carInformacionInicial = false;
  }


  regresar( dirty: boolean ) {
    this.router.navigate( [ 'apl/tipo-respaldo/' ] );
  }


}
